import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { companyAdminApi } from "./companyAdminApi";

export const store = configureStore({
  reducer: {
    companyAuth: authReducer,
    [companyAdminApi.reducerPath]: companyAdminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(companyAdminApi.middleware),
});
